import { ThemeProvider } from '@emotion/react';

import * as React from 'react';

import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import { searchTheme } from 'bundles/search-common/searchTheme';
import UnifiedAppCheckProvider from 'bundles/unified-common/providers/UnifiedAppCheckProvider';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!bundles/unified-home-common/__styles__/index';

// Note this component is attached to the route component. We don't have access to page data providers here.
const EnterprisePageWrapper: React.LegacyFunctionComponentWithChildren = ({ children }) => {
  return (
    <UnifiedAppCheckProvider>
      <ThemeProvider theme={searchTheme}>{children}</ThemeProvider>
    </UnifiedAppCheckProvider>
  );
};

/**
 * @description This wrapper is to provide overall functionality for the enterprise home page.
 */
export default compose<React.PropsWithChildren<{}>, {}>(
  withMarketingConsent,
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'program_home_v3',
      page: 'home_page',
    },
  }))
)(EnterprisePageWrapper);
